import type { EntityConfig } from '../types'

export const vampMonitoringEntity: EntityConfig = {
  id: 'vamp-monitoring',
  displayName: 'VAMP Monitoring',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'compliant', label: 'Compliant' },
      { value: 'warning', label: 'Warning' },
      { value: 'non-compliant', label: 'Non-Compliant' },
    ],
    options: [
      { value: 'compliant', label: 'Compliant', color: 'success' },
      { value: 'warning', label: 'Warning', color: 'warning' },
      { value: 'non-compliant', label: 'Non-Compliant', color: 'danger' },
    ],
    mappings: {
      all: [],
      compliant: ['compliant'],
      warning: ['warning'],
      'non-compliant': ['non-compliant'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['search', 'status'],
}
